import { string } from "yup";
import { apiClientes } from "../../config/api";
import { BoasVindas } from "../../interfaces/entities/GestaoDeCronicos/BoasVindas";
import { Horarios } from "../../interfaces/entities/Horarios";
import {
  IResponseQuestionnaire,
  ITermAccept,
  ITermResp,
} from "../../interfaces/enum/GestaoDeCronicosEnum";
import { getTokenClientes } from "../../Store/storages/AuthenticationStorage";
import { Mensagem } from "../../interfaces/entities/SaudeBemEstar/ChatComEquipeGC/Mensagem";
import { MessageToSend } from "../../interfaces/entities/SaudeBemEstar/ChatComEquipeGC/MessageToSend";
import { Estatisticas } from "../../interfaces/entities/SaudeBemEstar/EncerramentoGC/Estatisticas";
import { Response } from "../../interfaces/services/Response";
import { DoctorGC } from "../../interfaces/entities/SaudeBemEstar/GestaoDeCronicos/DoctorGC";
import { IHorarioDisponivel } from "../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/HorarioDisponivel";
import { UserData } from "../../pages/GestaoDeCronicos/PrimeiroAgendamento/AgendarAtendimento/ConfirmarDados";
import { AxiosError } from "axios";
import { Convite } from "../../interfaces/entities/SaudeBemEstar/PalestrasEventos/Convite";

export const getBoasVindas = async (): Promise<BoasVindas | null> => {
  try {
    const response = await apiClientes.get("cronicos/getboasvindas", {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` },
    });
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getBoasVindasDetalhes = async (): Promise<{
  textos: string[];
} | null> => {
  try {
    const response = await apiClientes.get("cronicos/getboasvindasdetalhe", {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` },
    });
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getHomeGestao = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetHomeGestao`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getRespostasQuestionario =
  async (idComunic: string): Promise<IResponseQuestionnaire | null> => {
    try {
      const response = await apiClientes.get(`cronicos/getquestoes?idComunic=${idComunic}`, {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      });
      const data = response.data;
      const formattedResponse: IResponseQuestionnaire = {
        listaQuestoesCronicos: data.listaQuestoesCronicos || [],
        listaQuestoesImc: data.listaQuestoesImc || [],
        listaTabelaImc: data.listaTabelaImc || [],
      };

      return formattedResponse;
    } catch (error) {
      console.log({ error });
      return null;
    }
  };

export const getHorariosDisponiveisPeriodo = (
  dtInicial: string,
  dtFinal: string
): Promise<Horarios[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const Authorization = `Bearer ${await getTokenClientes()}`;
      const headers = { Authorization };

      const response = await apiClientes.get(
        `cronicos/gethorariosdisponiveisperiodoadesao?dtInicial=${dtInicial}&dtFinal=${dtFinal}&tipoAtend=T`,
        { headers }
      );

      if (response?.data) {
        resolve(response.data);
      } else {
        reject(response);
      }
    } catch (error) {
      reject(error);
    }
  });
};

export const postSalvarIMC = async (
  listaQuestoesImc: IResponseQuestionnaire["listaQuestoesImc"]
): Promise<IResponseQuestionnaire["listaQuestoesImc"] | null> => {
  try {
    const response = await apiClientes.post(
      "cronicos/salvarrespquest",
      listaQuestoesImc,
      {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      }
    );
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getMeuProgresso = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetMeuProgresso`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getCronograma = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetCronograma`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getConhecaOPrograma = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetConhecaOPrograma`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};


export const getConversasAbertas = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetConversasAbertas`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getConversasConcluidas = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetConversasConcluidas`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getTempoRespostaChat = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetTempoRespostaChat`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getMensagens = async (idMsgOrigem: number): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetMensagens`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      params: { idMsgOrigem }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const novaConversa = async (assunto: string, mensagem: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Cronicos/NovaConversa',
      {
        assunto,
        mensagem
      },
      {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` }
      });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const postSalvarRespQuest = async (
  listaQuestoesImc: IResponseQuestionnaire["listaQuestoesImc"]
): Promise<Response | null> => {
  try {
    const response = await apiClientes.post(
      "cronicos/salvarrespquest",
      listaQuestoesImc,
      {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      }
    );
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const novaMensagem = async (mensagem: MessageToSend): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Cronicos/NovaMensagem',
      {
        idMsgOrigem: mensagem.idMsgOrigem,
        mensagem: mensagem.mensagem || '',
        anexoB64: mensagem.anexoB64 || '',
        nomeAnexo: mensagem.nomeAnexo || ''
      },
      {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` }
      });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const postSalvarRespQuestCronicos = async (
  listaQuestoesCronicos: IResponseQuestionnaire["listaQuestoesCronicos"]
): Promise<Response | null> => {
  try {
    const response = await apiClientes.post(
      "cronicos/salvarrespquest",
      listaQuestoesCronicos,
      {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      }
    );
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getTermoRespCronicos = async (): Promise<ITermResp | null> => {
  try {
    const response = await apiClientes.get(
      "TermoResponsabilidade/RetornaTermoResponsabilidadeCronicos",
      {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      }
    );
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getTermoRetornoAceiteCronicos =
  async (): Promise<ITermAccept | null> => {
    try {
      const response = await apiClientes.get(
        "termoresponsabilidade/retornaaceitetermocronicos",
        {
          headers: { Authorization: `Bearer ${await getTokenClientes()}` },
        }
      );
      return response.data;
    } catch (error) {
      console.log({ error });
      return null;
    }
  };

export const getTermoAceiteCronicos = async (
  idTermo: number,
  aceite: boolean
): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(
      `/TermoResponsabilidade/AceitaTermoResponsabilidade?idTermo=${idTermo}&indAceite=${aceite ? "S" : "N"
      }`,
      {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      }
    );
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getMensagemPreAgenda = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(
      `cronicos/getmensagempreagendamento`,
      {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      }
    );
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getAnexoMensagem = async (message: Mensagem): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetAnexoMensagem`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      params: { idMsg: message.idMensagem, idAnexo: message.idAnexo }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getTermoAltaCronicos = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/termoresponsabilidade/retornatermoresponsabilidadealtacronicos`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const aceiteAltaPaciente = async (idTermoAlta: string, idComunic: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post(`/Cronicos/AceiteAltaPaciente`,
      { idTermoAlta, idComunic },
      {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` },

      });
    if (response.data) {
      return response.data;
    }
    return null;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getEstatisticasPrograma = async (): Promise<Estatisticas | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetEstatisticasPrograma`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });

    if (response?.data) {
      return {
        atendimentos: response.data.atendimentos,
        diasJuntos: response.data.diasJuntos,
        eventos: response.data.eventos,
        textos: response.data.textos || [],
        imagemBase64: response.data.imagens?.length ? response.data.imagens[0] : null,
      }
    } else {
      return null;
    }
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getMeusAtendimentos = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetMeusAtendimentos`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getInstrucoesAtendimento = async (tipoAtend: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetInstrucoesAtendimento`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      params: { tipoAtend: tipoAtend }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const postCronicosAgendar = async (resp: Horarios): Promise<Response | null> => {
  try {
    const response = await apiClientes.post(`/Cronicos/Agendar `, resp, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` },
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getPrestadoresAgendamentoGestao = async (idEspec: number, tipoAgendamento: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetPrestadoresAgendamentoGestao`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      params: { idEspec, tipoAgendamento }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getFiltersAgendamentoCronicos = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Cronicos/GetFiltersAgendamentoCronicos`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getHorariosDisponiveisPeriodoGestao = async (doctor: DoctorGC, dtInicial: Date, dtFinal: Date, tipoAtend: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/Cronicos/GetHorariosDisponiveisPeriodoGestao', {
      params: {
        idPrestador: doctor.idPrestador,
        idEspec: doctor.idEspec,
        idInstal: doctor.idInstal,
        dtInicial,
        dtFinal,
        tipoAtend
      },
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const agendarGestao = async (
  doctor: DoctorGC, tipoAtend: string, horario: IHorarioDisponivel, dadosContato: UserData, idPlanoCuidPac: string
): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Cronicos/AgendarGestao', {
      idInstal: horario.idInstal,
      idPrestador: horario.idPrestador,
      espec: doctor.idEspec,
      data: `${horario?.data} ${horario?.hora}`,
      email: dadosContato.email,
      tel: dadosContato.tel,
      cel: dadosContato.cel,
      tipoAtend: tipoAtend,
      idPlanoCuidPac: idPlanoCuidPac
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } }
    );
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getConviteEvento = async (idComunic: string, idEventoUsr: string): Promise<Convite> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.get("/Cronicos/GetConviteEvento", {
      headers, params: {
        idComunic, idEventoUsr
      }
    });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};

export const confirmarInteresseEvento = async (data: { idComunic: string, idCtrlEventoUsr: string }): Promise<Response | null> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.post("Cronicos/ConfirmarIntesseConviteEvento", data, { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};

export const cancelarIntesseEvento = async (data: { idComunic: string, idCtrlEventoUsr: string }): Promise<Response | null> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.post("Cronicos/CancelarIntesseConviteEvento", data, { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};
